import { StoreExt } from '@utils/reactExt'
import { USER_PENALTY_TYPE } from '@v2/constants/common'
import { IAutoApplyUserPenalty } from '@protocol/penalty'
import _ from 'lodash'

export class PenaltyStore extends StoreExt {

  checkUserPenalty = async (penaltyType: USER_PENALTY_TYPE): Promise<string> => {
    try {

      if (_.isNil(penaltyType)) {
        return null
      }

      const result = await this.api.penalty.checkUserPenalty({ penaltyType })
      return result.penaltyMessage
    } catch (err) {
      console.error(err)
    }
  }

  autoApplyChatFloodPenalty = async (): Promise<IAutoApplyUserPenalty.Schema> => {
    try {
      return this.api.penalty.autoApplyChatFloodPenalty({ anchorTime: new Date() })
    } catch (err) {
      console.error(err)
    }
  }
}

export default new PenaltyStore()
